import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../base/base-component.component';
import { SiteSettingModel, AuthenticationService } from '../../../services';

@Component({
  selector: 'side-left-bar',
  templateUrl: './side-left-bar.component.html',
  styleUrls: ['./side-left-bar.component.css']
})
export class SideLeftBarComponent extends BaseComponent implements OnInit {

  @Input()
  siteSettingModel: SiteSettingModel;
  isCage = false;

  userIsOwner: boolean;
  userIsDev: boolean;
  userIsEditor: boolean;
  userIsReadWrite: boolean;
  userIsReader: boolean;

  constructor(
    translateService: TranslateService,
    private authenticationService: AuthenticationService) {
    super(translateService);
    this.setTranslateContext('SideLeftBarComponent');
  }

  ngOnInit() {
    this.userIsOwner = this.authenticationService.userHasRole("Owner");
    this.userIsDev = this.authenticationService.userHasRole("Developer");
    this.userIsEditor = this.authenticationService.userHasRole("Editor");
    this.userIsReadWrite = this.authenticationService.userHasRole("ReadWrite");
    this.userIsReader = this.authenticationService.userHasRole("Reader");
  }

}
